<template lang="pug">
  div(:class="b()" @keyup.enter="onClickNext")
    adviser-avatar(:class="b('avatar')" :image="adviser.avatar")
    div(:class="b('question')")
      div(:class="b('title')") {{ question.title }}
      div(
        v-if="question.description"
        v-html="question.description"
        :class="b('description')"
      )
    div(:class="b('body')")
      .notification(v-if="notification" :class="`is-${notification.type}`" v-html="notification.body").is-hidden-mobile
      div
        component(
          v-if="choice"
          :value="choiceSelected"
          v-bind="choice"
          :is="choice.component ? choice.component : 'choices'"
          :disabled="isDisabled"
          @input="onChoice"
        )
        div(:class="b('form-wrapper')")
          component(
            v-if="formComponent"
            ref="form"
            :is="formComponent"
            :last-answer="lastAnswer"
            :populated-data="populatedData"
            :disabled="isDisabled"
            @submit="onSubmitForm"
          )
        .notification(v-if="notification" :class="`is-${notification.type}`" v-html="notification.body").is-hidden-tablet
        div(:class="b('buttons-container')")
          button(
            v-if="renderNextButton"
            :class="b('action-button')"
            :disabled="nextButtonIsDisabled"
            type="button"
            @click="onClickNext"
          ).button.is-primary.is-large
            span {{ nextButtonText }}&nbsp;
            i.rtc-icon.rtc-chevron-right
          div(
            v-if="renderBackButton"
            :disabled="requesting"
            :class="b('back-button')"
            @click="onClickBack"
          ) Repetir pregunta anterior
</template>

<script>
  import AdviserAvatar from './adviser-avatar';
  import ProductChoice from '@/components/inputs/product-choice';
  import Choices from '@/components/inputs/choices';

  export const FORM_TYPE_QUESTION = 'FORM_TYPE_QUESTION';
  export const CHOICES_TYPE_QUESTION = 'CHOICES_TYPE_QUESTION';
  export const INFORMATIVE_QUESTION = 'INFORMATIVE_QUESTION';

  export default {
    name: 'step',

    data() {
      return {
        choiceSelected: this.step?.choice?.default,
      };
    },

    props: {
      step: { type: Object, required: true },
      requesting: { type: Boolean, default: false },
      canRewind: { type: Boolean, default: false },
      current: { type: Boolean, default: false },
      hasNextStep: { type: Boolean, default: false },
      populatedData: { type: Object },
      adviser: { type: Object, required: true },
      lastAnswer: { type: Object },
      nextButtonText: { type: String, default: 'Click o Presiona "Enter" para continuar' },
      notification: { type: Object },
    },

    computed: {
      isDisabled() {
        return !this.current || this.requesting;
      },

      question() {
        return this.step?.question;
      },

      formComponent() {
        return this.step?.form?.component;
      },

      choice() {
        return this.step?.choice;
      },

      questionType() {
        if (this.formComponent) return FORM_TYPE_QUESTION;
        else if(this.choice) return CHOICES_TYPE_QUESTION;
        else return INFORMATIVE_QUESTION;
      },

      nextButtonIsDisabled() {
        if(
          this.requesting ||
          (this.questionType === CHOICES_TYPE_QUESTION && this.choiceSelected === null)
        ) return true
        else return false;
      },

      renderNextButton() {
        return !this.choice && this.current && (this.hasNextStep || this.formComponent);
      },

      renderBackButton() {
        return this.current && this.canRewind;
      },
    },

    methods: {
      onClickNext() {
        if(this.nextButtonIsDisabled) return;

        switch (this.questionType) {
          case CHOICES_TYPE_QUESTION:
            return this.$emit('submit-choice', this.choiceSelected);
          case FORM_TYPE_QUESTION:
            return this.$refs.form.onSubmit();
          case INFORMATIVE_QUESTION:
            return this.$emit('next-step');
        }
      },

      onSubmitForm(data) {
        this.$emit('submit-form', data);
      },

      onClickBack() {
        this.$emit('previous-step');
      },

      onChoice(val) {
        this.choiceSelected = val;

        if(val !== null) {
          this.$emit('submit-choice', val);
        }
      },
    },

    components: {
      Choices,
      ProductChoice,
      AdviserAvatar,
    },
  };
</script>

<style lang="sass" scoped>
  @import '~@/sass/mixins'

  .step
    display: flex
    flex-wrap: wrap
    padding: 0 20px

    +tablet
      padding: 0

    &__question
      flex: 1

    &__body
      width: 100%
      padding-top: 24px

      +tablet
        padding-left: 79px + 24px

    &:focus
      outline: 0

    .adviser-avatar
      width: 55px
      height: 55px
      margin-right: 12px
      flex-shrink: 0

      +tablet
        width: 79px
        height: 79px
        margin-right: 24px

    &__question
      font-size: 16px
      margin-top: 4px

      +tablet
        font-size: 18px

    &__title
      font-weight: 500
      margin-bottom: 7px

    &__buttons-container
      margin-top: 32px
      text-align: center

      +tablet
        text-align: left


    &__action-button
      width: 100%
      height: auto !important
      padding: 11px 16px
      white-space: pre-wrap

      i
        font-size: 1.4em

    &__back-button
      margin-top: 23px

      font-size: 14px
      font-weight: 500
      color: $primaryColor
      cursor: pointer

    .notification
      padding: .75rem 1rem
      font-size: 14px

</style>